import React, { useState } from "react";
import KeysTable from "../components/KeysTable";
import CertificatesTable from "../components/CertificatesTable";
import { X } from "lucide-react";
import { useCbomContext } from "../context/CbomContext";
import LibraryTable from "components/LibraryTable";

const DeviceDetails: React.FC = () => {
  const [activeButton, setActiveButton] = useState("keys");
  const { showCbomComponent, setShowCbomComponent } = useCbomContext();
  const handleClick = (buttonName: string) => {
    setActiveButton(buttonName);
  };
  return (
    <>
      <div className="h-full">
        <div
          className={
            !showCbomComponent
              ? "p-2 bg-white rounded-lg h-full"
              : "p-10 fixed inset-0 z-20 bg-gray-600 bg-opacity-50 overflow-hidden w-screen h-screen flex items-center justify-center"
          }
        >
          {/* <div className="p-10 fixed inset-0 z-20 bg-gray-600 bg-opacity-50 overflow-y-auto h-screen w-screen flex items-center justify-center"> */}
          <div className="w-full p-2 bg-white rounded-lg flex flex-col h-full">
            <div className="flex justify-between items-center mb-4">
              <h1 className="text-xl font-bold text-custom-blue7 pl-2">
                CBOM Records
              </h1>
              {showCbomComponent && (
                <>
                  <button
                    className="p-2 bg-custom-blue7 rounded-full"
                    onClick={() => {
                      setShowCbomComponent(false);
                    }}
                  >
                    <X size={20} className="text-gray-50" />
                  </button>
                </>
              )}
            </div>
            <div className="flex flex-row justify-start w-full pl-2">
              <div className="space-x-2">
                <button
                  className={`px-6 py-2 rounded-t-md border-t-2 border-l-2 border-r-2 w-[150px] 
                      ${
                        activeButton === "keys"
                          ? "bg-custom-blue8 text-custom-blue6 "
                          : "bg-custom-blue7 text-white"
                      }
                      focus:outline-none
                    `}
                  onClick={() => handleClick("keys")}
                >
                  Keys
                </button>
                <button
                  className={`px-6 py-2 rounded-t-md border-t-2 border-l-2 border-r-2 w-[150px] 
                      ${
                        activeButton === "certificates"
                          ? "bg-custom-blue8 text-custom-blue6 "
                          : "bg-custom-blue7 text-white"
                      }
                      focus:outline-none
                    `}
                  onClick={() => handleClick("certificates")}
                >
                  Certificates
                </button>
                <button
                  className={`px-6 py-2 rounded-t-md border-t-2 border-l-2 border-r-2 w-[150px] 
                      ${
                        activeButton === "libraries"
                          ? "bg-custom-blue8 text-custom-blue6 "
                          : "bg-custom-blue7 text-white"
                      }
                      focus:outline-none
                    `}
                  onClick={() => handleClick("libraries")}
                >
                  Libraries
                </button>
              </div>
            </div>
            <div className="flex-1 overflow-hidden">
              {activeButton === "keys" && <KeysTable />}
              {activeButton === "certificates" && <CertificatesTable />}
              {activeButton === "libraries" && <LibraryTable />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeviceDetails;
